<div mat-dialog-title>
    {{ label |translate}}
    <span class="float-right pointer" (click)=" close()">
        <i class="fa fa-times close-btn "></i>
    </span>

</div>
<div mat-dialog-content>
  
    <form [formGroup]="titleForm" >
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always" >
                        <mat-label>
                            {{'Title'|translate}}
                        </mat-label>
                        <input matInput formControlName="title" [placeholder]="'Enter title'|translate">
                    </mat-form-field>
                </div>
            </div>
    </form>
        


</div>




<mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn mx-1 mx-1 tallite-action" (click)="close()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn   mx-1 tallite-action" type="submit" (click)="save()">
        {{ 'BTN.submit' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>



</mat-dialog-actions>